import api from './api';

const agentContentSelectionsService = {
  // Get agent's selected content cards
  getSelections: async () => {
    const response = await api.get('/agent/content-selections');
    return response.data;
  },

  // Save agent's content card selections
  saveSelections: async (selectedCardIds) => {
    const response = await api.post('/agent/content-selections', {
      selectedCardIds
    });
    return response.data;
  },

  // Update display order of selected content cards
  updateOrder: async (orderedCardIds) => {
    const response = await api.put('/agent/content-selections/order', {
      orderedCardIds
    });
    return response.data;
  },

  // Remove a specific content card selection
  removeSelection: async (cardId) => {
    const response = await api.delete(`/agent/content-selections/${cardId}`);
    return response.data;
  },

  // Get selection statistics
  getStats: async () => {
    const response = await api.get('/agent/content-selections/stats');
    return response.data;
  }
};

export default agentContentSelectionsService;
